import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import DivLayout from 'components/sales/divLayout/divLayout';
import DatePicker from 'components/sales/datePicker/datePicker';
import moment from 'moment';

const RmAssignTicket = ({
  fetchPmAssignee,
  pmAssigneeList,
  postTicketAssignment,
  match,
  fetchRmTicketDetails,
  rmTicketDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [assigneeId, setassigneeId] = useState('');
  const [maintenanceDate, setMaintenanceDate] = useState('');
  const [slotBooked, setSlotBooked] = useState('');
  const [isModal, setIsModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button href="#" onClick={() => onAssign()} className="btn btn-primary">
          <img src={Images?.ArrowRight} alt=""></img>
          {localization.assign}
        </Button>
      </Fragment>
    );
  };

  const onAssign = async () => {
    const data = {
      rm_ticket_id: match.params.id,
      assignee_id: assigneeId,
      maintenance_date:maintenanceDate,
      slot:slotBooked
    };
    if (assigneeId !== '') {
      setIsFiled(false);
      const res = await postTicketAssignment(data);
      if (res === true) {
        setIsModal(true);
      } else setIsModal(false);
    } else {
      setIsFiled(true);
    }
  };

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    (async () => {
      if (fetchPmAssignee) {
        setIsLoading(true);
        await fetchPmAssignee(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [fetchPmAssignee]);

  useEffect(() => {
    (async () => {
      if (fetchRmTicketDetails) {
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketDetails]);

  const handleDateChange = (val) => {
    setMaintenanceDate(val);
  };

  return (
    <Layout
      title={localization.assignTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      className={isFiled ? 'requiredFileds' : ''}
      linkUrl={`${baseUrl}/rm-tickets`}
    >
     
      <CardSection title={localization.assignEngineer}>
      <div className='row'>
       <div className="col-md-6 col-sm-12">
            <DropDownInput
              label={localization.assignTickets}
              data={pmAssigneeList}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
              getIdValue={(val) => setassigneeId(val.id)}
            />
        </div>
        <div className="col-md-6 col-sm-12">
            <DatePicker
              handleChange={handleDateChange}
              value={moment(maintenanceDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
              label={localization.scheduleMaintenanceDate}
              displayFormat="DD-MM-YYYY"
              returnFormat="DD-MM-YYYY"
              minimumDate={new Date()}
            />
        </div>
        <div className="col-md-6 col-sm-12">
            <DropDownInput
              label={`Select Slot`}
              data={[
                {name: "09:00 am",id: "09:00 am"},
                {name: "10:00 am",id: "10:00 am"},
                {name: "11:00 am",id: "11:00 am"},
                {name: "12:00 pm",id: "12:00 pm"},
                {name: "13:00 pm",id: "13:00 pm"},
                {name: "14:00 pm",id: "14:00 pm"},
                {name: "15:00 pm",id: "15:00 pm"},
                {name: "16:00 pm",id: "16:00 pm"},
                {name: "17:00 pm",id: "17:00 pm"},
                {name: "18:00 pm",id: "18:00 pm"},
                {name: "19:00 pm",id: "19:00 pm"},
                {name: "20:00 pm",id: "20:00 pm"},
                {name: "21:00 pm",id: "21:00 pm"},
              ]}
              required
              isStarRequired={true}
              getIdValue={(val) => setSlotBooked(val.id)}
              value={slotBooked}
            />
        </div>
        </div>
      </CardSection>
      <CardSection title={localization.rmTicket}>
        <div className="details-listing">
          <DivLayout
            heading={localization.ticketId}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.ticket_id}
          />
          <DivLayout
            heading={localization.createdOn}
            data={
              rmTicketDetails &&
              rmTicketDetails.ticket &&
              rmTicketDetails.ticket.created_on.slice(0, 10)
            }
          />
          
          <DivLayout
            heading={localization.siteNumber}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_no}
          />
          <DivLayout
            heading={localization.siteName}
            data={
              rmTicketDetails.complains && rmTicketDetails.complains.site_name
            }
          />
          <DivLayout
            heading={localization.siteType}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_type}
          />
          <DivLayout
            heading={localization.contractType}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.contract_type}
          />

         
        </div>
      </CardSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.rmTicketAssigned}</h5>
          <Link to={`${baseUrl}/rm-tickets`} className="btn btn-primary mb-4">
            {localization.viewRMTickets} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default RmAssignTicket;
